import * as React from 'react';
import type { SVGProps } from 'react';
import type { IconProps, ForwardedIconComponent } from './types';
const SpeechBubbleOutlined = (React.forwardRef<SVGSVGElement, SVGProps<SVGSVGElement> & IconProps>(function SpeechBubbleOutlined({
  title,
  titleId,
  size = '1em',
  ...props
}, ref) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" ref={ref} aria-labelledby={titleId} {...props}>
        {title ? <title id={titleId}>{title}</title> : null}
        <path fillRule="evenodd" clipRule="evenodd" d="M15 2.5H9c-4.42 0-8 3.58-8 8v11h2l3-3h9c4.42 0 8-3.58 8-8s-3.58-8-8-8Zm0 14H5.17l-2.18 2.18v-8.17c0-3.31 2.69-6 6-6h6c3.31 0 6 2.69 6 6s-2.69 6-6 6l.01-.01Z" fill="currentColor" />
      </svg>;
}) as ForwardedIconComponent);
export default SpeechBubbleOutlined;